import TextInputWithInlineLabel from './TextInputWithInlineLabel.jsx';
import { formatCurrency, getCurrencySymbol } from '../lib/CurrencyHelpers.js';

const MoneyInput = ({
    id,
    label,
    className,
    value,
    inputClassName,
    onChange,
    placeholder,
    autoFocus,
    required,
}) => {
    const currencySymbol = getCurrencySymbol();
    const length = currencySymbol.length;

    return (
        <TextInputWithInlineLabel
            id={id}
            label={label}
            prefix={currencySymbol}
            value={value}
            onChange={onChange}
            inputClassName={(length < 3 ? 'pl-8 ' : 'pl-12 ') + (inputClassName||'')}
            className={className}
            placeholder={placeholder}
            autoFocus={autoFocus}
            required={required}
        />
    );
};

export default MoneyInput;
